export default __webpack_public_path__ + "static/media/info.7df9e8ca.svg";